import { RequestPasswordResetRequest } from './../auth.actions'
import { getRequestPasswordResetState } from './../auth.selectors'
import { Component, OnInit, OnDestroy } from '@angular/core'
import Validator from '@shared/validatorjs/src/validator'
import { Store, select } from '@ngrx/store'
import { UpdateField, SetDefaultData } from '../auth.actions'
import FormTrait from 'src/app/traits/form.trait'
import { Map } from 'immutable'
import { Subscription } from 'rxjs'

@Component({
  selector: 'app-request-password-reset',
  templateUrl: './request-password-reset.component.html',
  styleUrls: ['./request-password-reset.component.css'],
})
export class RequestPasswordResetComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  public isLoading: boolean
  public isSucceed: boolean
  private state$: Subscription

  constructor(public store: Store<any>) {
    super()
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('requestPasswordReset'))
    this.state$ = this.store
      .pipe(select(getRequestPasswordResetState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
        this.isSucceed = state.get('isSucceed')
      })
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      email: 'required|email',
    }

    const validator = new Validator(
      {
        email: data.get('email'),
      },
      rules,
    )

    return validator
  }

  public handleFieldChange(e: any): void {
    this.store.dispatch(
      new UpdateField(
        e.target.name,
        e.target.value,
        'requestPasswordReset.data',
      ),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(e.target.name),
        'requestPasswordReset',
      ),
    )
  }

  public onSubmit(e: Event): void {
    e.preventDefault()
    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(new RequestPasswordResetRequest(payload))
    } else {
      this.store.dispatch<any>(
        new UpdateField(
          'validationErrors',
          validation.errors.errors,
          'requestPasswordReset',
        ),
      )
    }
  }
}
